<template>
  <Modal
    :show="show"
    cancel-text=""
    action-text=""
    :disabled="disabled"
    @close="$emit('close')"
  >
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <p class="text-body-1 mb-0">
        {{ publishLine }}
      </p>
      <p class="text-body-1 mb-0">
        Published jobs become visible to all users.
      </p>
    </template>
    <template #actions>
      <DpplNewButton
        class="bulk-modal-action text-button-1"
        variant="flat"
        color="primary"
        :disabled="disabled"
        :loading="loading"
        @click="$emit('confirm')"
      >
        Publish
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  count: { type: Number, default: 0 },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
});

defineEmits(['close', 'confirm']);

const title = computed(() => (
  props.count === 1 ? 'Publish 1 Profile' : `Publish ${props.count} Profiles`
));

const publishLine = computed(() => (
  props.count === 1
    ? 'This will publish 1 job profile.'
    : `This will publish ${props.count} job profiles.`
));
</script>

<style scoped lang="less">
.bulk-modal-action {
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}
</style>
